import {Payload} from "../../../../../core/service/payload/payload";

export class PartnerSaveAdditionalPropertyPayload implements Payload{
    key: string;
    value: object;

    constructor (key: string, value: object){
        this.key = key;
        this.value = value;
    }
}